/**
 * @file Proxy constant
 * @module constant.proxy
 * @author Surmon <https://github.com/surmon-china>
 */

export enum ProxyModule {
  Default = 'default',
  BiliBili = 'bilibili',
  Instagram = 'instagram',
  YouTube = 'youtube',
  NetEasyMusic = '163',
  Disqus = 'disqus'
}
